import { Flex, Loader } from "monday-ui-react-core";

interface LoadingPageProps {
  label?: string;
}

export default function LoadingPage({ label }: LoadingPageProps) {
  return (
    <Flex
      direction={Flex.directions.COLUMN}
      align={Flex.align.CENTER}
      justify={Flex.justify.CENTER}
      style={{ width: "100vw", height: "100vh" }}
    >
      <Loader size={Loader.sizes.MEDIUM} />
      <span style={{ fontFamily: "var(--font-family)" }}>{label && <p>{label}</p>}</span>
    </Flex>
  );
}
